<template>
  <div>
    <!-- <v-card-title class="modal-cadastro-titulo">
       {{ item. }}
    </v-card-title> -->
    <!-- <div class="modal-extrato-credito-titulo-total"></div> -->

    <v-card-text class="modal-cadastro-form">
      <v-skeleton-loader
        :loading="loadingTable"
        :transition="'fade-transition'"
        height="350px"
        type="table">
        <v-data-table
          :headers="headers"
          :items="listExtratoJogosCassino"
          :items-per-page.sync="itensPerPage"
          flat
          dense
          show-expand
          single-expand
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar 
              flat 
              color="white"
              class="toolbar"
            >
              <v-row>
                <v-col cols="12" md="3">
                  <FiltroRangeDate @input="filtrar" :value="rangeDate" />              
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    append-icon="search"
                    label="Id da aposta"
                    single-line
                    hide-details
                    v-on:keyup.enter="buscarPorIdAposta"
                    v-model="idAposta"
                    color="primary"
                    solo
                    dense
                  />     
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:item.winner="{item}">
            <!-- {{ item.status === 'W' ? item.transactions.find(it => it.entry.entryTypeId === 'CLTCPRC').value : '-' }} -->
            <template v-if="item.status === 'W'">
              {{ item.transactions.find(it => it.entry.entryTypeId === 'CLTCPRC').value | currency }}
            </template>
            <template v-else>
              -
            </template>
          </template>


          <template v-slot:item.value="{item}">
            {{ item.value | currency }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="box-table-palpites">
                <v-data-table
                  :headers="headersSubTable"
                  :items="item.transactions"
                  hide-default-footer
                  dense
                  :items-per-page="item.transactions.length"
                >
                <template v-slot:item.value="{item}">
                  {{ item.value | currency }}
                </template>

                <template v-slot:item.created="{item}">
                  {{ item.created | datas }}
                </template>

                </v-data-table>
              </div>
            </td>
          </template>

          <template v-slot:footer>
            <div class="d-flex align-center justify-space-between">
              <div class="qtd-paginacao">
                {{ pageStart }}
                -
                {{ pageStop }}
                de
                {{ totalExtratoJogosCassino }}
              </div>
              <v-pagination
                v-model="page"
                :length="numberOfPages"
                circle
                :disabled="loadingTable"
                :total-visible="10"
                class="box-table-paginacao"
                v-if="numberOfPages > 1"></v-pagination>
            </div>
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card-text>
  </div>
</template>

<script>
import variables from '@/assets/styles/helpers/_variables.scss'
import { mapGetters } from 'vuex'
import moment from 'moment'
import listagemTables from './listagemTables'

export default {
  name: 'UsuariowebExtratoJogos',
  mixins: [listagemTables],
  components: {
    FiltroRangeDate: () => import('@/views/components/filtroRangeDate')
  },
  data: () => ({
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'Game', value: 'game.name' },
      { align: 'start', class: 'table-header', text: 'Data Aposta', value: 'createdFull' },
      { align: 'start', class: 'table-header', text: 'Round', value: 'round.round' },
      { align: 'start', class: 'table-header', text: 'Valor', value: 'value' },
      { align: 'start', class: 'table-header', text: 'Status', value: 'status' },
      { align: 'start', class: 'table-header', text: 'Valor Prêmio', value: 'winner' },
      { align: 'start', class: 'table-header', text: '', value: 'icon' }
    ],
    headersSubTable: [
      { sortable: false, class: 'table-header', text: 'Data', value: 'created' },
      { sortable: false, class: 'table-header', text: 'Transaction', value: 'transactionProvider' },
      { sortable: false, class: 'table-header', text: 'Tipo', value: 'entry.entryTypes.description' },
      { sortable: false, class: 'table-header', text: 'Valor', value: 'value' }
    ],
    rangeDate: {
      start: moment().add(-7, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    itensPerPage: 50,
    page: 1,
    idAposta: '',
  }),
  
  computed: {
    ...mapGetters('usuariosWeb', {item: 'item', listExtratoJogosCassino: 'listExtratoJogosCassino', loadingTable: 'loadingTable', totalExtratoJogosCassino: 'totalExtratoJogosCassino'}),
    variables: () => variables,
  },

  mounted () {
    this.$emit('updatedRangeDate', this.rangeDate)
  },

  methods: {
    init () {},
    clearItens () {},
    totalValue (bonus) {
      let self = this
      if (bonus){
        return self.listExtratoJogosCassino.reduce((acc, item)=> (item.transmissions?.jsonFlags?.isGameBonusWeb ? parseFloat(item.value): 0) + acc, 0)
      } 
      return self.listExtratoJogosCassino.reduce((acc, item)=> (!item.transmissions?.jsonFlags?.isGameBonusWeb ? parseFloat(item.value): 0) + acc, 0)
      
    },

    formatarData () {
      const self = this
      self. dateFormatted = moment(self.date).format('DD/MM/YYYY')
    },

    filtrar (e) {
      if (e.start !== '' && e.end !== '') {
        this.rangeDate = {
          start: e.start,
          end: e.end
        }
        this.$emit('obterJogosPorData', this.rangeDate, this.page)
      }
    },

    buscarPorIdAposta () {
      this.$emit('obterJogosPorIdAposta', this.idAposta)
    },
  }
}
</script>

<style lang="scss" src="@/assets/styles/view/usuarios-web.scss">
</style>